var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"activity-operator",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.listeners.add($event)}}},[(_vm.props.activityInfo.status === 1)?_c('span',{staticClass:"operator add",style:(_vm.props.btnStyle)},[_vm._v(" 立即抢购 ")]):(_vm.props.activityInfo.status === 0)?_c('span',{class:[
      'operator',
      'remind',
      _vm.props.hasSetRemind ? 'has-set-remind' : ''
    ],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.listeners.seckillRemind($event)}}},[_vm._v(" "+_vm._s(_vm.props.hasSetRemind ? '已设置提醒' : '提醒我')+" ")]):_c('span',{staticClass:"activity-end"},[_vm._v("已结束")]),(_vm.props.showCount && _vm.props.count && _vm.props.activityInfo.status === 1)?_c('p',{class:[
      'count',
      {
        'over-num': _vm.props.count > 99
      }
    ]},[_vm._v(" "+_vm._s(_vm.props.count > 99 ? '...' : ("" + (_vm.props.count)))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }